export default __webpack_public_path__ + "static/media/router.7ec185a2.webp";